/**
 * Die **Kommentarvorschau**: der Commit-Kommentar einer Listenzeile,
 * dreizeilig, mit dem ganzen Text im Titel.
 *
 * **An einer Stelle für beide Listen.** Der Revisionsstrom und der Befundvorrat
 * zeigen denselben Kommentar; zwei Aufbauten wären zwei Antworten auf dieselbe
 * Frage, sobald einer nachgezogen wird und der andere nicht — dieselbe
 * Entscheidung wie bei `FindingCell` und `IssueReferenceCell`.
 *
 * **Sie ist die eine ungedeckelte Spalte je Liste.** `DataTable` setzt kein
 * `table-layout: fixed`, also geht der Überschuss an die Spalten, deren Inhalt
 * breiter ist als ihre Zuweisung; liegt nur diese eine offen, wächst auf einem
 * breiteren Schirm allein sie (`listWidths.ts`). Ihr `width` ist deshalb ein
 * Boden und kein Maß, und einen `maxWidth` trägt ihre Spalte nicht.
 *
 * **Dreizeilig und nicht zweizeilig.** Die Zeile ist durch die Befundzelle
 * daneben — Titel plus Namensband — ohnehin zwei Zeilen hoch; die dritte kostet
 * die Tabelle fast keine Höhe und trägt den halben Gewinn an Auskunft.
 * `DataTable` setzt `white-space: nowrap` auf die ganze Tabelle; diese Zelle
 * hebt das für sich auf und klemmt stattdessen auf drei Zeilen.
 *
 * **Die Vorschau bleibt Text; der Ticketverweis steht daneben** (#113). Ein
 * Link *in* dieser Zelle hätte an derselben Stelle zwei Ziele — der Klick auf
 * die Zeile öffnet die Revision —, und welches gemeint war, entschiede die
 * Pixelbreite einer Ticketnummer. Das ist der Einwand aus #101, und er gilt
 * weiter; er wird nur nicht mehr mit „gar kein Link" beantwortet, sondern mit
 * der Spalte „Ticket" unmittelbar daneben: Zwei Ziele an einer Stelle sind ein
 * Rätsel, zwei Ziele in zwei Spalten sind eine Tabelle.
 */

import type { ReactElement } from "react";

/** Wie viele Zeilen die Vorschau zeigt, bevor sie abschneidet. */
const LINES = 3;

export function MessageCell({ text }: { text: string }): ReactElement {
  return (
    <span
      title={text}
      style={{
        display: "-webkit-box",
        WebkitLineClamp: LINES,
        WebkitBoxOrient: "vertical",
        whiteSpace: "normal",
        overflow: "hidden",
      }}
    >
      {text}
    </span>
  );
}
